import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import headersList from "Constants/headersList";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { bindActionCreators } from "redux";

import { Helmet } from "react-helmet";
import { instance, instanceMultipart } from "Actions/AxiosInstance";
import filterIcon from "Assets/newicons/action/filter/outline/filter-outline-16px.svg";
import uploadIcon from "Assets/newicons/action/upload/outline/upload-outline-16px.svg";
import phoneIcon from "Assets/newicons/services/phone-bill/outline/phone-bill-outline-16px.svg";
import mailIcon from "Assets/newicons/user-interface/mail/outline/mail-outline-16px.svg";
import mobileIcon from "Assets/newicons/user-interface/mobile/outline/mobile-outline-16px.svg";
import behanceIcon from "Assets/Svg/behance-24-px.svg";
import designationIcon from "Assets/newicons/attribute/designation/outline/designation-outline-16px.svg";
import CallOutNew from "Component/Headers/callOutNew";
import NoRecordFoundImg from "Assets/Images/no-record.svg";

import dribbbleIcon from "Assets/Svg/dribbble-24-px.svg";
import githubIcon from "Assets/Svg/github-24-px.svg";
import linkedinIcon from "Assets/Svg/linkedin-24-px.svg";
import empty from "Assets/Svg/recruit-no-requistion.svg";
import classNames from "classnames";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import DynamicForm from "Component/DynamicForm";
import { multiselectinputconverter } from "Component/DynamicForm/Fields/MultiSelect";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import DrawerHeader from "Component/Headers/drawerHeader";
import SearchSq from "Component/Material-ui/SearchSq";
import Thumbnail from "Component/Thumbnail/ThumbnailBig";
import { withSnackbar } from "notistack";
import React from "react";
import Dropzone from "react-dropzone";
import ReactPhoneInput from "react-phone-input-2";
import { connect } from "react-redux";
import Select from "react-select";
import { getFormattedImageLink } from "Utils";
import loader from "Assets/Gif/loader.gif";
import blogIcon from "../../../../Assets/Svg/blogs.svg";
import facebookIcon from "../../../../Assets/Svg/facebooklogo.svg";
import hangoutIcon from "../../../../Assets/Svg/hangout.svg";
import pinterestIcon from "../../../../Assets/Svg/pintrest.svg";
import qouraIcon from "../../../../Assets/Svg/quara.svg";
import skypIcon from "../../../../Assets/Svg/skype.svg";
import slackIcon from "../../../../Assets/Svg/slack.svg";
import twitterIcon from "../../../../Assets/Svg/twitter.svg";
import whatsAppIcon from "../../../../Assets/Svg/watsapp.svg";

const styles = () => ({
  drawerPaper: {
    width: "30%",
    padding: 16,
  },
});

const POSTDATA = {
  name: null,
  mobilenumber: "",
  callingcode: null,
  emailid: null,
  city: null,
  requisitionjobid: null,
  expectedsalary: "",
  noticeperiod: "",
  profilepicpath: null,
  elementryskill: null,
  advanceskill: null,
  resumepath: null,
  coverletterpath: null,
  candidatecontact: [],
  candiatequestionfeedback: [],
  sourcetypeid: null,
  candidateexperience: [],
  candidateeducation: [],
};

class index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      postdata: { ...POSTDATA, candidatecontact: [] },
      permissions: { editable: true, readonly: true },

      allCandidates: [],
      contacttypeid: null,
      jobtemplateid: "",
      sourceid: [],
      sources: [],
      candidateSources: [],
      pageloading: true,
      locationList: [],
      locationId: [],
      filterdata: [],
      sourcelist: [],
      categorysourcelist: [],
      createnew: false,
      filter: false,

      contactType: [],
      contactTag: [],

      // contacttypevalue: "",

      jobtemplates: [],

      name: null,
      emailid: null,

      mobilenumber: "",

      city: null,
      // state: null,

      requisitionjobid: null,
      contactInit: {
        contacttypeid: null,
        contacttagid: 2,
        contacttypevalue: null,
        candidatecontactid: null,
        candidateid: null,
        contacttype: null,
      },
      jobemailid: null,
      joburl: null,
      advanceskill: null,
      elementryskill: null,
      advancelanguage: null,
      elementrylanguage: null,
      workinglanguage: null,
      jobTemplates: [],
      // resumepath: null,
      coverletterpath: null,
      sourcetypeid: null,
      selectedsource: {},
      // candidateeducation: [
      //   {
      //     institutename: null,
      //     universityname: null,
      //     educationgradeid: null,
      //     fromdate: null,
      //     todate: null,
      //     studylevel: null,
      //     studyfield: null,
      //     candidateeducationid: null,
      //     candidateid: null,
      //   },
      // ],
      // candidateexperience: [
      //   {
      //     workrolename: null,
      //     companyname: null,
      //     companyaddress: null,
      //     employementtypeid: null,
      //     companydoj: null,
      //     seprationdate: null,
      //     jobsummary: null,
      //     candidateexperienceid: null,
      //     candidateid: null,
      //   },
      // ],
      candidatecontact: [
        {
          contacttypeid: null,
          contacttagid: null,
          contacttypevalue: null,
          candidatecontactid: null,
          candidateid: null,
        },
      ],
      candiatequestionfeedback: [
        {
          requisitionid: null,
          requisitionjobid: null,
          requisitionjobquestionid: null,
          feedback: null,
          requisitionjobquestioninputoptionids: null,
          candiatequestionfeedbackid: null,
          candidateid: null,
        },
      ],
    };
    this.handleChange = this.handleChange.bind(this);
    this.configCandidateDetails = this.configCandidateDetails.bind(this);
    this.getallcandidate = this.getallcandidate.bind(this);
    this.addContact = this.addContact.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.uploadDoc = this.uploadDoc.bind(this);
  }

  componentDidMount() {
    if (this.props.isrecruiter) {
      this.getallcandidate();
      this.GetContactType();
      this.GetOfficeLocationList();
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  getallcandidate = () => {
    const data = {
      jobtemplateid: this.state.jobtemplateid,
      sourceid: this.state.sourceid.map((x) => x.displayvalue),
      locationId: this.state.locationId.map((x) => x.displayvalue),
    };
    instance
      .post("recruit/getallcandidate", data)
      .then((result) => {
        this.setState({
          allCandidates: result.data.result,
          backupList: result.data.result,
          pageloading: false,
        });
      })
      .catch((error) => {
        this.setState({ pageloading: false });
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  handleSearch(e) {
    const { backupList, allCandidates } = this.state;
    const filterList = backupList.filter(
      (item) =>
        item.name.toLowerCase().search(e.target.value.toLowerCase()) !== -1,
    );
    this.setState({
      searchValue: e.target.value,
      allCandidates: e.target.value ? filterList : backupList,
      // isdata: filterList.length == 0 ? true : false,
    });
  }

  GetContactType() {
    instance
      .get("superuser/getmastercode/ContactType")
      .then((result) => {
        const contactType = [];
        contactType.push(
          { displayname: "Select Contact Type", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ contactType });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  inittalentpoolfilter() {
    instance
      .get("recruit/inittalentpoolfilter")
      .then((result) => {
        const filterdata = [];
        filterdata.push(...result.data.result);
        // const jobtemplates = result.data.result[0].jobTemplate;
        const jobtemplates =
          result.data.result[0].jobTemplate &&
          result.data.result[0].jobTemplate.map((x) => ({
            displayname: x.designationname,
            displayvalue: x.requisitionjobid,
          }));

        const sourcelist = result.data.result[0].source;
        const opt = [];
        const arrCategory = [];
        sourcelist.forEach((source) => {
          if (
            !arrCategory.some(
              (category) =>
                category.subcandidatesourcecategoryid ==
                source.subcandidatesourcecategoryid,
            )
          ) {
            arrCategory.push({
              subcandidatesourcecategoryid: source.subcandidatesourcecategoryid,
              categoryname: source.categoryname,
            });
          }
        });

        arrCategory.forEach((category) => {
          opt.push({
            label: category.categoryname,
            options: sourcelist.filter(
              (source) =>
                source.subcandidatesourcecategoryid ==
                category.subcandidatesourcecategoryid,
            ),
          });
        });

        this.setState({
          filterdata,
          jobtemplates,
          sourcelist,
          categorysourcelist: opt,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  // GetCandidateSources() {
  //   instance
  //     .get("recruit/getallcandidatesource/1")
  //     .then((result) => {
  //       const sources = [];
  //       sources.push(
  //         // { displayname: "Select Contact Type", displayvalue: "" },
  //         ...result.data.result,
  //       );
  //       const candidateSources = result.data.result.map(
  //         (x) =>
  //           x.candidatesourcetype &&
  //           x.candidatesourcetype.map((x1) => x1.sourcetypename),
  //       );
  //       this.setState({ sources, candidateSources });
  //     })
  //     .catch((error) => {
  //       const CommonError = error.response
  //         ? error.response.data.error.message
  //         : error.message;
  //       this.props.enqueueSnackbar(CommonError, { variant: "error" });
  //     });
  // }

  handleChange(name, value, indx = null) {
    const { postdata, selectedContactType, contactInit } = this.state;

    if (name == "contacttypevalue" || name == "contacttypeid") {
      if (name == "contacttypeid") {
        contactInit[name] = value && value.displayvalue;
        contactInit.contacttype = value;
      } else {
        contactInit[name] = value;
      }

      this.setState({ contactInit });
    } else if (
      name == "jobtemplateid" ||
      name == "sourceid" ||
      name == "locationId"
    ) {
      this.setState({ [name]: value });
    } else if (name == "sourcetypeid") {
      postdata[name] = value.displayvalue;
      postdata.selectedsource = value;

      this.setState({
        postdata,
      });
    } else {
      postdata[name] = value;
      this.setState({
        postdata,
      });
    }
  }

  OnPhoneChange(field, value) {
    this.state.postdata.countryname = value.name;
    this.state.postdata.callingcode = value.dialCode;
    this.state.postdata.mobilenumber = field;
    field = field.replace(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, "");
    const no = field.replace(value.dialCode, "");
    this.state.postdata.no = no.trim();

    const { postdata } = this.state;

    this.setState({ postdata });
  }

  addContact = () => {
    const { postdata, contactInit } = this.state;

    if (!contactInit.contacttypeid || !contactInit.contacttypevalue) {
      this.props.enqueueSnackbar("Please add contact", {
        variant: "error",
      });
    } else {
      delete contactInit.contacttype;
      postdata.candidatecontact.push(contactInit);
      this.setState({
        postdata,
        contactInit: {
          contacttypeid: null,
          contacttagid: 2,
          contacttypevalue: "",
          candidatecontactid: null,
          candidateid: null,
          contacttype: null,
        },
      });
    }
  };

  onDeleteDoc(key) {
    const { postData } = this.state;
    postData[key] = null;
    this.setState({
      postData,
    });
  }

  configCandidateDetails() {
    const { postdata } = this.state;

    if (!postdata.name) {
      this.props.enqueueSnackbar("Please add name", {
        variant: "error",
      });
      return;
    } else if (!postdata.emailid) {
      this.props.enqueueSnackbar("Please add email", {
        variant: "error",
      });
      return;
    } else if (!postdata.mobilenumber) {
      this.props.enqueueSnackbar("Please add mobile number", {
        variant: "error",
      });
      return;
    } else if (!postdata.city) {
      this.props.enqueueSnackbar("Please add city", {
        variant: "error",
      });
      return;
    } else if (!postdata.noticeperiod) {
      this.props.enqueueSnackbar("Please add notice period", {
        variant: "error",
      });
      return;
    } else if (!postdata.expectedsalary) {
      this.props.enqueueSnackbar("Please add expected salary", {
        variant: "error",
      });
      return;
    } else if (!postdata.advanceskill) {
      this.props.enqueueSnackbar("Please add advance skill", {
        variant: "error",
      });
      return;
    } else if (!postdata.elementryskill) {
      this.props.enqueueSnackbar("Please add elementry skill", {
        variant: "error",
      });
      return;
    } else if (!postdata.resumepath) {
      this.props.enqueueSnackbar("Please upload resume", {
        variant: "error",
      });
      return;
    } else {
      // this.props.enqueueSnackbar("Please add name", {
      //   variant: "error",
      // });
    }

    postdata.mobilenumber = postdata.no;

    this.setState({
      isDisableSaveButton: true,
    });

    instance
      .post("recruit/configcandidateapplication", postdata)
      .then(() => {
        this.setState(
          {
            drawerOpen: false,
            createnew: false,
            postdata: { ...POSTDATA, candidatecontact: [] },
            isDisableSaveButton: false,
            contactInit: {
              contacttypeid: null,
              contacttagid: 2,
              contacttypevalue: "",
              candidatecontactid: null,
              candidateid: null,
              contacttype: null,
            },
          },
          () => this.getallcandidate(),
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
        this.setState({
          isDisableSaveButton: false,
        });
      });
  }

  GetOfficeLocationList() {
    const data = {
      subscriptionid: this.props.SubscriptionData.subscriptionid,
    };
    instance
      .post(`subscription/allcompanylocation`, data)
      .then((result) => {
        this.setState({ locationList: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  async uploadDoc(key, files) {
    const { postdata } = this.state;

    const formData = new FormData();
    formData.append("file", files[0]);

    instanceMultipart
      .post(
        `/drive/uploaddocument/${this.props.SubscriptionData.subscriptionid}/${this.props.SubscriptionData.employeeid}`,
        formData,
      )
      .then((resp) => {
        postdata[key] = resp.data.result[0].imagepath;

        this.setState({
          postdata,
        });
      });
  }

  render() {
    const { classes } = this.props;
    const { postdata, allCandidates, sourcelist, categorysourcelist } =
      this.state;
    return (
      <div className="content-outer-wrapper-with-tab">
        <Helmet>
          <title>{headersList.Recruit.TalentPool.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
            <div>
              {this.state.pageloading ? (
                <img className="loader" src={loader} />
              ) : (
                <div>
                  <Grid container className="margin-bottom-24" spacing={3}>
                    <Grid item md={4} sm={12}>
                      <div className="normal-dark">
                        {this.state.allCandidates &&
                          this.state.allCandidates.length > 0 &&
                          `Showing all ${
                            this.state.allCandidates &&
                            this.state.allCandidates.length
                          } candidates`}
                      </div>
                    </Grid>
                    <Grid
                      item
                      md={8}
                      sm={12}
                      className="display-flex"
                      justify="flex-end"
                    >
                      {this.state.allCandidates.length > 0 && (
                        <SearchSq
                          placeholder="Search"
                          value={this.state.searchValue}
                          onChange={this.handleSearch}
                          style={{ marginRight: 16, width: 250 }}
                        />
                      )}
                      {this.state.allCandidates.length == 0 &&
                        this.state.searchValue && (
                          <SearchSq
                            placeholder="Search"
                            value={this.state.searchValue}
                            onChange={this.handleSearch}
                            style={{ marginRight: 16, width: 250 }}
                          />
                        )}
                      {this.state.allCandidates.length > 0 && (
                        <div
                          className="margin-right-16 filter-icon cursor-pointer"
                          onClick={() =>
                            this.setState(
                              {
                                drawerOpen: true,
                                filter: true,
                                createnew: false,
                              },
                              () => {
                                this.inittalentpoolfilter();
                              },
                            )
                          }
                          style={{ width: 50 }}
                        >
                          <img
                            src={filterIcon}
                            className="vertical-center"
                          ></img>
                        </div>
                      )}
                      {this.state.permissions.editable &&
                        this.state.allCandidates.length > 0 && (
                          <div style={{ width: 130 }}>
                            <Button
                              variant="contained"
                              className="btn btn-primary-md-blue"
                              color="primary"
                              onClick={() =>
                                this.setState(
                                  {
                                    drawerOpen: true,
                                    createnew: true,
                                    filter: false,
                                  },
                                  () => {
                                    this.inittalentpoolfilter();
                                  },
                                )
                              }
                              style={{ width: 148 }}
                            >
                              Add candidate
                            </Button>
                          </div>
                        )}
                    </Grid>
                  </Grid>
                  {allCandidates && allCandidates.length > 0 ? (
                    <Grid container spacing={2}>
                      {this.state.allCandidates &&
                        this.state.allCandidates.map((item) => (
                          <Grid
                            key={item.candidateid}
                            item
                            sm={12}
                            md={3}
                            style={{ height: 278, display: "flex" }}
                          >
                            <Paper
                              className="rounded-rectangle-paper padding16 position-rel width100"
                              // style={{ width: "calc(20% - 32px)" }}
                            >
                              <div className="text-center">
                                <img
                                  src={getFormattedImageLink(
                                    item.profilepicpath && item.profilepicpath,
                                  )}
                                  height="96"
                                  width="96"
                                  style={{
                                    borderRadius: 50,
                                    objectFit: "cover",
                                  }}
                                />
                                <p className="small-blue t-bold margin-top-8 margin-bottom-4">
                                  {item.name}
                                </p>

                                <div
                                  className="display-flex"
                                  style={{
                                    justifyContent: "center",
                                    height: 22,
                                  }}
                                >
                                  {item.contact
                                    ? item.contact
                                        .filter(
                                          (y) =>
                                            y.contacttype == "Hangout" ||
                                            y.contacttype == "LinkedIn" ||
                                            y.contacttype == "Github" ||
                                            y.contacttype == "FB" ||
                                            y.contacttype == "Twitter",
                                        )
                                        .map((x) => (
                                          <div>
                                            {x.contacttype == "Hangout" && (
                                              <Tooltip
                                                title={x.contactvalue}
                                                placement="top"
                                              >
                                                <img
                                                  src={hangoutIcon}
                                                  className="margin-right-8"
                                                  height="16"
                                                ></img>
                                              </Tooltip>
                                            )}

                                            {x.contacttype == "FB" && (
                                              <Tooltip
                                                title="Visit facebook profile"
                                                placement="top"
                                              >
                                                <a
                                                  href={`https://www.facebook.com/sharer/sharer.php?u=${x.contactvalue}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                >
                                                  <img
                                                    src={facebookIcon}
                                                    className="margin-right-8"
                                                    height="16"
                                                  ></img>
                                                </a>
                                              </Tooltip>
                                            )}
                                            {x.contacttype == "Twitter" && (
                                              <Tooltip
                                                title="Visit twitter profile"
                                                placement="top"
                                              >
                                                <a
                                                  href={`https://twitter.com/intent/tweet?url=${x.contactvalue}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                >
                                                  <img
                                                    src={twitterIcon}
                                                    className="margin-right-8"
                                                    height="16"
                                                  ></img>
                                                </a>
                                              </Tooltip>
                                            )}
                                            {x.contacttype == "LinkedIn" && (
                                              <Tooltip
                                                title="Visit linkedIn profile"
                                                placement="top"
                                              >
                                                <a
                                                  href={`https://www.linkedin.com/shareArticle?mini=true&url=${x.contactvalue}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                >
                                                  <img
                                                    src={linkedinIcon}
                                                    className="margin-right-8"
                                                    height="16"
                                                  ></img>
                                                </a>
                                              </Tooltip>
                                            )}

                                            {x.contacttype == "Github" && (
                                              <Tooltip
                                                title="Visit github profile"
                                                placement="top"
                                              >
                                                <a href={x.contactvalue}>
                                                  <img
                                                    src={githubIcon}
                                                    className="margin-right-8"
                                                    height="16"
                                                  ></img>
                                                </a>
                                              </Tooltip>
                                            )}
                                          </div>
                                        ))
                                    : "-"}
                                </div>
                                <div>
                                  <div>
                                    <img
                                      src={mailIcon}
                                      className="margin-right-8"
                                    ></img>

                                    <Tooltip
                                      title={item.emailid}
                                      placement="top"
                                    >
                                      <p className="small-dark-secondary ellipsis width80 inline-block text-align-left margin-top-2">
                                        {item.emailid}
                                      </p>
                                    </Tooltip>
                                  </div>
                                  <div>
                                    <img
                                      src={mobileIcon}
                                      className="margin-right-8"
                                    ></img>

                                    <p className="small-dark-secondary ellipsis width80 inline-block text-align-left margin-top-2">
                                      {item.mobilenumber}
                                    </p>
                                  </div>
                                  <Tooltip
                                    title={item.jobdetails}
                                    placement="top"
                                  >
                                    <div>
                                      <img
                                        src={designationIcon}
                                        className="margin-right-8"
                                      ></img>

                                      <p className="small-dark-secondary ellipsis width80 inline-block text-align-left margin-top-2">
                                        {item.jobdetails}
                                      </p>
                                    </div>
                                  </Tooltip>
                                </div>
                              </div>
                            </Paper>
                          </Grid>
                        ))}
                    </Grid>
                  ) : (
                    <div>
                      {this.state.searchValue &&
                      this.state.allCandidates.length == 0 ? (
                        <div className="position-rel">
                          <DefaultComp
                            heading="No record found"
                            imageSrc={NoRecordFoundImg}
                          />
                        </div>
                      ) : (
                        <div className="position-rel">
                          <DefaultComp
                            heading="There are no candidates to display"
                            subheading="Get started by adding your first candidate!"
                            imageSrc={empty}
                          />
                          <div className="text-center margin-top-24">
                            <Button
                              className="btn btn-primary-md-blue"
                              variant="contained"
                              onClick={() =>
                                this.setState(
                                  {
                                    drawerOpen: true,
                                    createnew: true,
                                    filter: false,
                                  },
                                  () => {
                                    this.inittalentpoolfilter();
                                  },
                                )
                              }
                            >
                              Add candidate
                            </Button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>

            <Drawer
              anchor="right"
              open={this.state.drawerOpen}
              onClose={() =>
                this.setState({
                  drawerOpen: false,
                  postdata: { ...POSTDATA, candidatecontact: [] },
                  contactInit: {
                    contacttypeid: null,
                    contacttagid: 2,
                    contacttypevalue: "",
                    candidatecontactid: null,
                    candidateid: null,
                    contacttype: null,
                  },
                })
              }
              classes={{
                paper: classNames(classes.drawerPaper, "planner-drawer"),
              }}
            >
              <DrawerHeader
                header={
                  this.state.filter ? "Filter talent pool" : "Add new talent"
                }
                isbackarrow={false}
                closeDrawer={() =>
                  this.setState({
                    drawerOpen: false,
                    postdata: { ...POSTDATA, candidatecontact: [] },
                    contactInit: {
                      contacttypeid: null,
                      contacttagid: 2,
                      contacttypevalue: "",
                      candidatecontactid: null,
                      candidateid: null,
                      contacttype: null,
                    },
                  })
                }
              />
              {this.state.filter ? (
                <div>
                  <DynamicForm
                    fields={selectinputconverter({
                      value: this.state.jobtemplateid,
                      placeholder: "Select job",
                      label: "Job applied",
                      options: this.state.jobtemplates,
                    })}
                    onChange={(selectedid) => {
                      this.handleChange("jobtemplateid", selectedid);
                    }}
                  />

                  <DynamicForm
                    fields={multiselectinputconverter({
                      value: this.state.sourceid,
                      placeholder: "Select source(s)",
                      label: "Source",
                      options: this.state.sourcelist,
                    })}
                    onChange={(selectedid) => {
                      this.handleChange("sourceid", selectedid);
                    }}
                  />
                  <DynamicForm
                    fields={multiselectinputconverter({
                      value: this.state.locationId,
                      placeholder: "Select location",
                      label: "Reporting location",
                      options: this.state.locationList,
                    })}
                    onChange={(selectedid) => {
                      this.handleChange("locationId", selectedid);
                    }}
                  />

                  <div>
                    <Button
                      className="btn btn-primary-md-blue margin-top-24 margin-right-16"
                      variant="contained"
                      onClick={() => {
                        this.setState({ drawerOpen: false }, () =>
                          this.getallcandidate(),
                        );
                      }}
                    >
                      Apply filter
                    </Button>
                    <Button
                      className="btn btn-primary-md-blue margin-top-24"
                      variant="contained"
                      onClick={() => {
                        this.setState(
                          {
                            drawerOpen: false,
                            jobtemplateid: null,
                            sourceid: [],
                            locationId: [],
                          },
                          () => this.getallcandidate(),
                        );
                      }}
                    >
                      Reset filter
                    </Button>
                  </div>
                </div>
              ) : (
                <div>
                  <p className="inout-label">Upload profile picture</p>
                  {postdata.profilepicpath == null ? (
                    <Tooltip title="Click here to upload" placement="top">
                      <Dropzone
                        onDrop={(e) => this.uploadDoc("profilepicpath", e)}
                        multiple={false}
                        accept="image/*"
                        maxSize={2000000}
                        className="drag-drop"
                      >
                        <div
                          className="cursor-pointer"
                          style={{
                            width: 80,
                            border: "1px dashed #d9dadb",
                            padding: 16,
                            borderRadius: 4,
                            marginBottom: 16,
                            background: "#fff",
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                              textAlign: "center",
                            }}
                          >
                            <img
                              src={uploadIcon}
                              className="vertical-middle text-center display-block margin-bottom-8"
                              style={{ margin: "auto" }}
                            ></img>
                            <span className="extra-small-dark-secondary">
                              Click here to upload
                            </span>
                          </div>
                        </div>
                      </Dropzone>
                    </Tooltip>
                  ) : (
                    <Thumbnail
                      key="key"
                      onDelete={() => this.onDeleteDoc("profilepicpath")}
                      onEdit={(file) => this.uploadDoc("profilepicpath", file)}
                      filetypes="image/*"
                      doc={{
                        url: getFormattedImageLink(postdata.profilepicpath),
                      }}
                    />
                  )}
                   <p className="input-label" style={{marginBottom:8}}>
                    Note:<br></br>
                      Supported files: .gif, .jpeg, .jpg and .png<br></br>
                      Max size: 2MB
                  </p>
                  <DynamicForm
                    fields={textinputconverter({
                      value: postdata.name,
                      label: "Candidate Name",
                      placeholder: "Enter name",
                    })}
                    onChange={(value) => {
                      this.handleChange("name", value);
                    }}
                  />
                  <DynamicForm
                    fields={textinputconverter({
                      value: postdata.emailid,
                      label: "Email",
                      placeholder: "Enter email id",
                    })}
                    onChange={(value) => {
                      this.handleChange("emailid", value);
                    }}
                  />
                  <p className="input-label">Phone</p>
                  <div className="margin-bottom-16">
                    <ReactPhoneInput
                      defaultCountry={"in"}
                      countryCodeEditable={false}
                      className="form-control"
                      value={postdata.mobilenumber}
                      // onChange={(value) => this.handleChange("mobilenumber", value)}
                      onChange={this.OnPhoneChange.bind(this)}
                      InputProps={{ maxLength: 15, minLength: 5 }}
                    />
                  </div>

                  <div>
                    <DynamicForm
                      fields={textinputconverter({
                        value: postdata.city,
                        label: "City name",
                        placeholder: "Enter city name",
                      })}
                      onChange={(value) => {
                        this.handleChange("city", value);
                      }}
                    />
                  </div>

                  <DynamicForm
                    fields={selectinputconverter({
                      value: postdata.requisitionjobid,
                      placeholder: "Select job",
                      label: "Job applied",
                      options: this.state.jobtemplates,
                    })}
                    onChange={(selectedid) => {
                      this.handleChange("requisitionjobid", selectedid);
                    }}
                  />

                  <p className="input-label">Select source</p>
                  <div className="margin-bottom-16">
                    <Select
                      className="selectsearch inlindClass width100"
                      onChange={(selectedItem) =>
                        this.handleChange("sourcetypeid", selectedItem)
                      }
                      options={this.state.categorysourcelist}
                      getOptionLabel={(option) => option.displayname}
                      getOptionValue={(option) => option.displayvalue}
                      value={this.state.postdata.selectedsource}
                      placeholder="Select Source"
                      isClearable={true}
                    />
                  </div>
                  <DynamicForm
                    fields={textinputconverter({
                      value: postdata.advanceskill,
                      label: "Advance skill",
                      placeholder: "Enter skill",
                    })}
                    onChange={(value) => {
                      this.handleChange("advanceskill", value);
                    }}
                  />

                  <DynamicForm
                    fields={textinputconverter({
                      value: postdata.elementryskill,
                      label: "Elementry skill",
                      placeholder: "Enter skill",
                    })}
                    onChange={(value) => {
                      this.handleChange("elementryskill", value);
                    }}
                  />

                  <div>
                    <DynamicForm
                      fields={integerinputconverter({
                        value: postdata.noticeperiod,
                        label: "Notice period",
                        placeholder: "Enter notice period",
                      })}
                      onChange={(value) => {
                        this.handleChange("noticeperiod", value);
                      }}
                    />
                  </div>

                  <div>
                    <DynamicForm
                      fields={integerinputconverter({
                        value: postdata.expectedsalary,
                        label: "Expected salary",
                        placeholder: "Enter salary",
                      })}
                      onChange={(value) => {
                        this.handleChange("expectedsalary", value);
                      }}
                    />
                  </div>

                  <div>
                    <div className="margin-bottom-16 drawer-last-select">
                      <p className="input-label">Contact type</p>
                      <Select
                        className="selectsearch ContactType1"
                        onChange={(selectedid) => {
                          this.handleChange("contacttypeid", selectedid);
                        }}
                        options={this.state.contactType}
                        getOptionLabel={(option) => option.displayname}
                        getOptionValue={(option) => option.displayvalue}
                        value={this.state.contactInit.contacttype}
                        placeholder="Contact Type"
                      />
                    </div>

                    {this.state.contactInit.contacttype && (
                      <div>
                        <DynamicForm
                          fields={textinputconverter({
                            value: this.state.contactInit.contacttypevalue,
                            label: "Details",
                            placeholder: "Enter details",
                          })}
                          onChange={(value) => {
                            this.handleChange("contacttypevalue", value, 1);
                          }}
                        />
                      </div>
                    )}
                  </div>
                  {postdata.candidatecontact &&
                    postdata.candidatecontact.length > 0 && (
                      <div>
                        <p className="small-dark-secondary margin-bottom-8">
                          All contact details
                        </p>
                        <Paper className="rounded-rectangle-paper padding16 margin-bottom-16 padding-bottom-8">
                          {postdata.candidatecontact &&
                            postdata.candidatecontact.map((item) => (
                              <div
                                className="display-flex margin-bottom-8"
                                style={{ alignItems: "center" }}
                              >
                                <img
                                  height="16"
                                  src={
                                    item.contacttypeid == 1
                                      ? mailIcon
                                      : item.contacttypeid == 2
                                      ? mobileIcon
                                      : item.contacttypeid == 3
                                      ? phoneIcon
                                      : item.contacttypeid == 4
                                      ? skypIcon
                                      : item.contacttypeid == 5
                                      ? hangoutIcon
                                      : item.contacttypeid == 6
                                      ? slackIcon
                                      : item.contacttypeid == 7
                                      ? facebookIcon
                                      : item.contacttypeid == 8
                                      ? twitterIcon
                                      : item.contacttypeid == 9
                                      ? linkedinIcon
                                      : item.contacttypeid == 10
                                      ? behanceIcon
                                      : item.contacttypeid == 11
                                      ? dribbbleIcon
                                      : item.contacttypeid == 12
                                      ? pinterestIcon
                                      : item.contacttypeid == 13
                                      ? githubIcon
                                      : item.contacttypeid == 14
                                      ? qouraIcon
                                      : item.contacttypeid == 15
                                      ? blogIcon
                                      : item.contacttypeid == 16
                                      ? whatsAppIcon
                                      : ""
                                  }
                                  style={{ marginRight: 8 }}
                                ></img>
                                <p className="small-dark-secondary">
                                  {item.contacttypevalue}
                                </p>
                              </div>
                            ))}
                        </Paper>
                      </div>
                    )}
                  <span
                    className="normal-blue t-bold cursor-pointer margin-bottom-8"
                    onClick={this.addContact}
                  >
                    + Add contact
                  </span>

                  <p className="input-label margin-top-16">Upload resume</p>
                  <div>
                    {postdata.resumepath == null ? (
                      <Tooltip title="Click here to upload" placement="top">
                        <Dropzone
                          onDrop={(e) => this.uploadDoc("resumepath", e)}
                          multiple={false}
                          accept="application/pdf,application/msword"
                          maxSize={2000000}
                          className="drag-drop"
                        >
                          <div
                            className="cursor-pointer"
                            style={{
                              width: "92%",
                              border: "1px dashed #d9dadb",
                              padding: 16,
                              borderRadius: 4,
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                textAlign: "center",
                              }}
                            >
                              <img
                                src={uploadIcon}
                                className="vertical-middle text-center display-block margin-bottom-8"
                                style={{ margin: "auto" }}
                              ></img>
                              <span className="extra-small-dark-secondary">
                                Click here to upload
                              </span>
                            </div>
                          </div>
                        </Dropzone>
                      </Tooltip>
                    ) : (
                      <Thumbnail
                        key="key"
                        onDelete={() => this.onDeleteDoc("resumepath")}
                        onEdit={(file) => this.uploadDoc("resumepath", file)}
                        filetypes="image/*"
                        doc={{
                          url: getFormattedImageLink(postdata.resumepath),
                        }}
                      />
                    )}
                  </div>
                  <div className="margin-top-8">
                  <p className="input-label">
                        Note:<br></br>
                          Supported files: .pdf and msword<br></br>
                          Max size: 2MB
                      </p>
                    {/* <CallOutNew
                      classnames="bg-light-blue width100"
                      header="Note: Supported file types are pdf and word file."
                      emoji="📌"
                      textcolor="#1e8ced"
                    /> */}
                  </div>
                  <p className="input-label margin-top-16">
                    Upload cover letter
                  </p>
                  <div>
                    {postdata.coverletterpath == null ? (
                      <Tooltip title="Click here to upload" placement="top">
                        <Dropzone
                          onDrop={(e) => this.uploadDoc("coverletterpath", e)}
                          multiple={false}
                          accept="application/pdf,application/msword"
                          maxSize={2000000}
                          className="drag-drop"
                        >
                          <div
                            className="cursor-pointer"
                            style={{
                              width: "92%",
                              border: "1px dashed #d9dadb",
                              padding: 16,
                              borderRadius: 4,
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                textAlign: "center",
                              }}
                            >
                              <img
                                src={uploadIcon}
                                className="vertical-middle text-center display-block margin-bottom-8"
                                style={{ margin: "auto" }}
                              ></img>
                              <span className="extra-small-dark-secondary">
                                Click here to upload
                              </span>
                            </div>
                          </div>
                        </Dropzone>
                      </Tooltip>
                    ) : (
                      <Thumbnail
                        key="key"
                        onDelete={() => this.onDeleteDoc("coverletterpath")}
                        onEdit={(file) =>
                          this.uploadDoc("coverletterpath", file)
                        }
                        filetypes="image/*"
                        doc={{
                          url: getFormattedImageLink(postdata.coverletterpath),
                        }}
                      />
                    )}
                  </div>
                  <div className="margin-top-8">
                  <p className="input-label">
                        Note:<br></br>
                          Supported files: .pdf and msword<br></br>
                          Max size: 2MB
                      </p>
                    {/* <CallOutNew
                      classnames="bg-light-blue width100"
                      header="Note: Supported file types are pdf and word file."
                      emoji="📌"
                      textcolor="#1e8ced"
                    /> */}
                  </div>

                  <div>
                    <Button
                      className="btn btn-primary-md-blue margin-top-16 margin-bottom-24"
                      variant="contained"
                      // onClick={() =>
                      //   this.setState({ drawerOpen: false, createnew: false })
                      // }
                      onClick={this.configCandidateDetails}
                      disabled={this.state.isDisableSaveButton}
                    >
                      Add talent
                    </Button>
                  </div>
                </div>
              )}
            </Drawer>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(index)));
